module.exports = __webpack_public_path__ + "static/media/web04_ch01.350e2a9b.png";